import { Button, Modal } from '@mairistem/composants';
import React from 'react';

interface StatutModalProps {
	onClose: () => void;
	onValidate: () => void;
	isLoading: boolean;
}

const DeleteDemandeCompteModal = ({
	onValidate,
	onClose,
	isLoading,
}: StatutModalProps) => (
	<Modal onClose={onClose} size="small" open>
		<Modal.Header>Suppression de la demande de compte</Modal.Header>
		<Modal.Content image>
			<p>
				Êtes-vous sûr de vouloir supprimer cette demande de compte ? Cette
				action est irréversible.
			</p>
		</Modal.Content>
		<Modal.Actions>
			<Button color="black" onClick={onClose}>
				Annuler
			</Button>
			<Button
				icon="checkmark"
				onClick={() => onValidate()}
				primary
				loading={isLoading}
			>
				Supprimer la demande de compte
			</Button>
		</Modal.Actions>
	</Modal>
);

export default DeleteDemandeCompteModal;
